import { render, staticRenderFns } from "./shanxiTrainingSupervisionSix.vue?vue&type=template&id=1f94743c"
import script from "./shanxiTrainingSupervisionSix.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingSupervisionSix.vue?vue&type=script&lang=js"
import style0 from "./shanxiTrainingSupervisionSix.vue?vue&type=style&index=0&id=1f94743c&prod&lang=less&scope=true"
import style1 from "./shanxiTrainingSupervisionSix.vue?vue&type=style&index=1&id=1f94743c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports